// extracted by mini-css-extract-plugin
module.exports = {"infoProtectionSection":"InfoProtectionSection_infoProtectionSection__20Le2"};